import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'syngenta-digital-cropwise-react-ui-kit';
import { FieldMessage } from 'components/UiKit/FormikFields';
import PersonFieldLabel from '../../../PersonFieldLabel';

function LicenseNumberField({
  title = '',
  licenseNumber = '',
  onChange,
  errors = null
}) {
  return (
    <div className="my-4 w-full">
      <div className="flex mr-6">
        <div className="w-full">
          <PersonFieldLabel htmlFor="license-number-input">
            {title}
          </PersonFieldLabel>
          <div
            data-testid="license-number-field"
            className="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2"
          >
            <div className="h-8">
              <Input
                id="license-number-input"
                name="applicatorLicense"
                value={licenseNumber ?? ''}
                onChange={onChange}
                status={errors ? 'error' : undefined}
              />
              <FieldMessage message={errors} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

LicenseNumberField.propTypes = {
  title: PropTypes.string,
  licenseNumber: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.string
};

export default LicenseNumberField;
